import ProceedButton from '@/components/buttons/ProceedButton'

export const formMixin = {
  components: {
    ProceedButton,
  },
  props: {
    bank: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      username: '',
      password: '',
      pin: null,
      captcha: null,
      isLoading: false,
    }
  },

  computed: {
    isProceedEnable() {
      return this.canProceed()
    },
  },

  methods: {
    canProceed() {
      return !!this.password && !!this.username
    },
    proceed() {
      if (!this.canProceed()) {
        return false
      }

      this.isLoading = true
      const password = this.password

      this.$emit('proceed', {
        password,
        username: this.username,
        pin: this.pin,
        captcha: this.captcha,
      })
      return true
    },
  },
}
